import { Component, Vue } from 'vue-property-decorator';
import UsersOverview from '@/components/users-overview';

import template from './users.vue';

@Component({
  mixins: [template],
  components: {
    UsersOverview
  },
})
export default class Users extends Vue {
  get userName(): string {
    return this.$Store.getters.USERNAME as string;
  }

  get company(): string {
    return this.$Store.state.company.company.name as string;
  }
}